import axios from 'axios';

export default {
  components: {
  },
  props: [
    'guest',
    'redirect',
  ],
  data () {
    return {
      util: require('../lib/util'),
      firstMe: null,
      me: this.$store.state.me,
      key: null,
      paths: process.env.TOP_PATHS.split(','),
      lastApp: this.$store.state.lastApp,
      appHistory: this.$store.state.appHistory,
      apps: this.$store.state.apps,
      logoutDate: null,
      loadingOverlay: false,
      config: require('../lib/config'),
      resizeEvent: null,
      titlePrefix: null,
      titleSuffixSeparator: ' - ',
      titleSuffix: 'TapFun',
    }
  },
  created() {
    this.axios.defaults.baseURL = '/player'
    this.session();
    this.loadApps();
    this.setTitle();
    window.addEventListener('blur', this._windowBlur);
    window.addEventListener('focus', this._windowFocus);
    window.addEventListener('scroll', this._windowScroll);
    window.addEventListener('orientationchange', this._windowOrientationChange);
    return this._created();
  },
  mounted() {
    // console.log('mounted');
    this._mounted();
    this.resizeEvent = window.addEventListener('resize', (e) => {
      this._resize(e);
    });
  },
  unmounted() {
    // console.log('unmounted');
    window.removeEventListener('resize', this.resizeEvent);
    window.removeEventListener('blur', this._windowBlur);
    window.removeEventListener('focus', this._windowFocus);
    window.removeEventListener('scroll', this._windowScroll);
    window.removeEventListener('orientationchange', this._windowOrientationChange);
    return this._unmounted();
  },
  methods: {
    session: async function(redirect = true, retry = false, keyCheckCallback = false) {
      let res;
      const beforeKey = this.key;
      try {
        res = await this.axios({
          url: '/session',
        }).catch((e) => {
          this.loadingOverlay = true;
        });
        if (!res) {
          await this.sleep(1000);
          return await this.session(redirect, true);
        }
      } catch (e) {
        await this.sleep(1000);
        return await this.session(redirect, true);
      }
      if (retry) {
        this.loadingOverlay = false;
      }
      this.$store.commit('setLastApp', res.data.lastApp);
      this.lastApp = res.data.lastApp;
      this.$store.commit('setAppHistory', res.data.appHistory);
      this.appHistory = res.data.appHistory;
      this.logoutDate = res.data.logoutDate;
      this.setMe(res.data.me, res.data);
      this.key = res.data.key;
      this.axios.defaults.headers.common['X-Tapfun-Session-Id'] = res.data.sessionId;

      // 新規登録コンバージョントラッキング
      if (res.data.me.registerConversionNotice) {
        gtag('event', 'conversion', {'send_to': 'AW-16815137145/y5oxCMybnvwZEPnCitI-'});
        twq('event', 'tw-oyzde-oyzeu', {});
      }

      if (keyCheckCallback && beforeKey !== null && beforeKey !== res.data.key) {
        keyCheckCallback();
      }

      if (redirect) {
        this.guestLoginRedirect();
      }
    },
    async loadApps() {
      this.axios({
        url: '/apps',
      }).then((r) => {
        this.apps = r.data.apps;
        this.$store.commit('setApps', r.data.apps);
        this._appsSeted();
      }).catch((e) => {
        console.log({ e });
      });
    },
    _appsSeted() {
    },
    setTitle(title) {
      if (!title && this.titlePrefix) title = this.titlePrefix;
      document.title = (this.config.EnvName ? '[' + this.config.EnvName + ']' : '') + (title ? title + this.titleSuffixSeparator : '') + this.titleSuffix;
    },
    guestLoginRedirect() {
      if (this.guest === true && this.me && !this.$route.query.noReplace) {
        this.$router.replace(this.redirect);
      }
      if (this.guest === false && !this.me) {
        this.$router.replace(this.redirect);
      }
    },
    setMe(me, session) {
      this.me = me;
      this.$store.commit('setMe', me);
      if (!this.firstMe) {
        this.firstMe = true;
        this._firstMeSeted();
      }
      this._meSeted(me, session);

      if (session && session.flash) {
        console.log(session.flash);

        if (this.$refs.layout && this.$refs.layout._flash) {
          this.$refs.layout._flash(session.flash);
        }
        this._flash(session.flash);
      }
    },
    demoAlert() {
      alert('デモ環境のため使用できません');
    },
    _created() {
    },
    _mounted() {
    },
    _unmounted() {
    },
    _resize() {
    },
    _meSeted() {
    },
    _firstMeSeted() {
    },
    _flash(flash, me) {
    },
    _windowBlur() {
      this.windowBlur();
    },
    _windowFocus() {
      this.session(false);
      this.windowFocus();
    },
    windowBlur() {
    },
    windowFocus() {
    },
    _windowScroll() {
    },
    _windowOrientationChange(e) {
    },
    sleep(waitSec) {
      return new Promise(function (resolve) {
          setTimeout(function() { resolve() }, waitSec);
      });
    },
    isSP() {
      const ua = navigator.userAgent;
      if (ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
        return true;
      } else {
        return false;
      }
    },
    showLoadingOverlay() {
      this.loadingOverlay = true;
    },
    hideLoadingOverlay() {
      this.loadingOverlay = false;
    },
  },
}
